export interface InviteProfessionalsResponse {
    // Will be false if at least one email was refused
    ok: boolean;
    // Number of emails that were actually sent succesfully
    sent: number;
    // Emails that were refused by Mandrake
    failedEmails: string[];
}
